// extracted by mini-css-extract-plugin
export default {"share-link-button":"ShareLink_share-link-button__ZOabO","share-link-img":"ShareLink_share-link-img__xsCAk"};